/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AddTimeOffRequest
 */
export interface AddTimeOffRequest {
  /**
   *
   * @type {string}
   * @memberof AddTimeOffRequest
   */
  teamMemberId: string;
  /**
   *
   * @type {LocalDate}
   * @memberof AddTimeOffRequest
   */
  startDate: LocalDate;
  /**
   *
   * @type {LocalDate}
   * @memberof AddTimeOffRequest
   */
  endDate: LocalDate;
  /**
   *
   * @type {string}
   * @memberof AddTimeOffRequest
   */
  kind: string;
  /**
   *
   * @type {string}
   * @memberof AddTimeOffRequest
   */
  note?: string | null;
}

/**
 * Check if a given object implements the AddTimeOffRequest interface.
 */
export function instanceOfAddTimeOffRequest(
  value: object,
): value is AddTimeOffRequest {
  if (!("teamMemberId" in value) || value["teamMemberId"] === undefined)
    return false;
  if (!("startDate" in value) || value["startDate"] === undefined) return false;
  if (!("endDate" in value) || value["endDate"] === undefined) return false;
  if (!("kind" in value) || value["kind"] === undefined) return false;
  return true;
}

export function AddTimeOffRequestFromJSON(json: any): AddTimeOffRequest {
  return AddTimeOffRequestFromJSONTyped(json, false);
}

export function AddTimeOffRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AddTimeOffRequest {
  if (json == null) {
    return json;
  }
  return {
    teamMemberId: json["teamMemberId"],
    startDate: json["startDate"],
    endDate: json["endDate"],
    kind: json["kind"],
    note: json["note"] == null ? undefined : json["note"],
  };
}

export function AddTimeOffRequestToJSON(json: any): AddTimeOffRequest {
  return AddTimeOffRequestToJSONTyped(json, false);
}

export function AddTimeOffRequestToJSONTyped(
  value?: AddTimeOffRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamMemberId: value["teamMemberId"],
    startDate: value["startDate"],
    endDate: value["endDate"],
    kind: value["kind"],
    note: value["note"],
  };
}
